export default __webpack_public_path__ + "static/media/bun-bird.33e6d57c.png";